import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import styled from "@emotion/styled";
import React from "react";
interface SimpleCardProps {
  showBg: boolean;
  children: React.ReactNode;
  title?: string;
  icon?: React.ReactNode;
}
function SimpleCard(props: SimpleCardProps) {
  return (
    <Content>
      {props.title && (
        <ContentLabel showBg={props.showBg}>
          <div>
            <TextSimple color="blue-02" size="title" weight="bold" font="gotham">
              {props.title}
            </TextSimple>
          </div>
          {props.icon}
        </ContentLabel>
      )}
      <ContentChildren>{props.children}</ContentChildren>
    </Content>
  );
}

export default SimpleCard;

const Content = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  grid-template-rows: 2.5em auto;
  margin: 20px 0;
  border-radius: 15px;
  overflow: hidden;
`;

const ContentLabel = styled.div<{ showBg: boolean }>`
  width: 100%;
  background-color: ${props => (props.showBg ? "var(--m-color-blue-01)" : "white")};
  display: flex;
  align-items: center;
  padding: 20px 25px;
  gap: 5px;
`;

const ContentChildren = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 20px 25px;
`;
